/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The rule order as committed, positions 0..n-1 in this sequence.
 * @export
 * @interface RuleReorderResponse
 */
export interface RuleReorderResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleReorderResponse
     */
    ruleIds: Array<string>;
}

/**
 * Check if a given object implements the RuleReorderResponse interface.
 */
export function instanceOfRuleReorderResponse(value: object): value is RuleReorderResponse {
    if ((!('ruleIds' in (value as Record<string, any>)) && !('rule_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['ruleIds'] === undefined && (value as Record<string, any>)['rule_ids'] === undefined)) return false;
    return true;
}

export function RuleReorderResponseFromJSON(json: any): RuleReorderResponse {
    return RuleReorderResponseFromJSONTyped(json, false);
}

export function RuleReorderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleReorderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ruleIds': json['rule_ids'],
    };
}

export function RuleReorderResponseToJSON(json: any): RuleReorderResponse {
    return RuleReorderResponseToJSONTyped(json, false);
}

export function RuleReorderResponseToJSONTyped(value?: RuleReorderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rule_ids': value['ruleIds'],
    };
}

